import { Location } from "@angular/common";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { ErrorType } from "src/app/enums/error-type.enum";
import { ApiService } from "src/app/services/api.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import endpoints from "src/app/helpers/endpoints";

@Component({
  selector: 'fury-checkout-settings',
  templateUrl: './checkout-settings.component.html',
  styleUrls: ['./checkout-settings.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class CheckoutSettingsComponent implements OnInit, OnDestroy {

  checkoutSettingsForm!: FormGroup;
  ngUnsubscribe = new Subject<void>();

  constructor(private apiService: ApiService, public location: Location) {}

  ngOnInit(): void {
    this.formInit();
    this.getCheckoutSettingsDetails();
  }

  formInit() {
    this.checkoutSettingsForm = new FormGroup({
      installmentLimits: new FormGroup({
        annuallyPlanInstallmentLimit: new FormControl("", [
          Validators.required,
          Validators.min(1),
          Validators.max(9),
        ]),
        twoYearsPlanIInstallmentLimit: new FormControl("", [
          Validators.required,
          Validators.min(1),
          Validators.max(9),
        ]),
        threeYearsPlanIInstallmentLimit: new FormControl("", [
          Validators.required,
          Validators.min(1),
          Validators.max(9),
        ]),
        fourYearsPlanIInstallmentLimit: new FormControl("", [
          Validators.required,
          Validators.min(1),
          Validators.max(9),
        ]),
        fiveYearsPlanIInstallmentLimit: new FormControl("", [
          Validators.required,
          Validators.min(1),
          Validators.max(9),
        ]),
      }),
      bankingPaymentStatus: new FormControl(false),
      onFrontendCheckout: new FormControl(false),
    });
  }
  getCheckoutSettingsDetails() {
    this.apiService
      .get(endpoints.checkoutSettings.getCheckoutSettings)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: HttpResponse<any>) => {
        if (res.body) {
          this.checkoutSettingsForm.patchValue(res.body?.checkout_setting);
        }
      });
  }

  update() {
    if (this.checkoutSettingsForm.valid) {
      this.apiService
        .post(
          endpoints.checkoutSettings.postCheckoutettings,
          this.checkoutSettingsForm.value
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (res: HttpResponse<any>) => {
            if (res.body) {
              this.apiService.alert(res.body.message, ErrorType.Success);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.apiService.alert(err.message, ErrorType.Error);
          },
        });
    } else {
      this.checkoutSettingsForm.markAllAsTouched();
    }
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
